import React, { useState, useEffect } from "react";
import "./Campaigns.css";
import ApiService from "../../services/Api.service";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Alert from "../../components/Alert/Alert";
import toast from "react-hot-toast";
import Pagination from "../../components/Pagination/Pagination";
import StatusBadge from "../../utilities/StatusBadge";
import FilterBar from "../../components/FilterBar/FilterBar";
import Loader from "../../components/Loader/Loader";
import { Eye, FilePlus, PhoneCall, Play, Square } from "lucide-react";
import CampaignCreateModal from "./CampaignCreateModal";
import { UploadFile } from "../UploadData/UploadFile";
import CampaignCallbackModel from "./CampaignCallbackModel";


export default function Campaigns() {
    const [Loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [sections, setSections] = useState([]);
    const [postsPerPage, setPostsPerPage] = useState(20);
    const [headers, setHeaders] = useState([]);
    const [dropDownData, setDropDownData] = useState([]);
    const [selectedItem, setSelectedItem] = useState([]);
    const [selectedItemCallBack, setSelectedItemCallBack] = useState([]);
    const [showModal, setShowModal] = useState(false);
     const [showCallbackModal, setCallbackModal] = useState(false);
    const [selectedRowIndex, setSelectedRowIndex] = useState(null);
    const [pagination, setPagination] = useState({
        page: 1,
        size: 20,
        total: 0,
        total_pages: 0,
    });
    const [alertValue, setAlertValue] = useState({
        show: false,
        message: "",
        variant: "success",
        position: "middle",
    });

    const validationSchema = yup.object().shape({
    });

    const {
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validationSchema),
    });

    const fetchDetail = async (page = 1, size = postsPerPage, payload = null) => {
        try {
            setLoading(true);
            if (!payload) {
                payload = {
                };
            }
            const res = await ApiService.getCampaignList(payload, { page, size });
            if (res.status === 200 && res.data) {
                setTableData(res.data.data);
                setPagination(res.data.pagination);
                setHeaders(res.data.header);
                setSelectedRowIndex(null);
                setLoading(false);
            }
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

    const fetchDropdownDetail = async () => {
        try {
            const subprocessRes = await ApiService.getSubprocesses();
            if (subprocessRes.status === 200) setDropDownData(subprocessRes.data)
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchDropdownDetail();
        fetchDetail();
    }, []);

    const handelSubmit = async (data) => {
        const payload = {
        };
        fetchDetail(1, postsPerPage, payload);
    };


    const handleClearFilters = () => {
        reset({});
        fetchDetail();
    };

    const handlePageSizeChange = (e) => {
        const newSize = Number(e.target.value);
        setPostsPerPage(newSize);
        fetchDetail(1, newSize);
        setSelectedRowIndex(null);
    };

    const mistableTh = {
        backgroundColor: "transparent",
        color: "rgba(43, 58, 103, 1)",
        fontFamily: "Nunito",
        fontSize: "13px",
        fontWeight: 700,
        lineHeight: "16px",
        letterSpacing: "0.1em",
        textAlign: "center",
    };

    const tableTdStyles = {
        backgroundColor: "#F7F7F7",
        fontFamily: "Nunito",
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "16px",
        letterSpacing: "0em",
        textAlign: "center",
        color: "#232122",
    };

    const handleAdd = (item) => {
        setSelectedItem(item)
        setShowModal(true)
    };
     const handleCallBack = (item) => {
        setSelectedItemCallBack(item)
        setCallbackModal(true)
    };

    const getFinalFileName = (file) => {
        const fileName = file.name;
        const fileExtension = fileName.split(".").pop().toLowerCase();
        return fileExtension === "csv"
            ? `${Date.now()}.${fileExtension}`
            : fileName;
    };
    const handleStart = async (campaignId) => {
        try {
            const res = await ApiService.startCampaign(campaignId);
            fetchDetail();
            if (res.status === 200 && res.data) {
                const msg = typeof res.data === 'string'
                    ? res.data
                    : (res.data?.message || res.data?.data);
                toast.success(msg || "Campaign started successfully");
            }
        } catch (err) {
            console.error("Error starting campaign:", err);
            setAlertValue({
                show: true,
                message: err.message || "❌ Failed to start campaign",
                variant: "danger",
                position: "middle",
            });
        }
    };

    const handleStop = async (campaignId) => {
        try {
            const res = await ApiService.stopCampaign(campaignId);
            fetchDetail();
            if (res.status === 200 && res.data) {
                const msg = typeof res.data === 'string'
                    ? res.data
                    : (res.data?.message || res.data?.data);
                toast.success(msg || "Campaign stopped successfully");
            }
        } catch (err) {
            console.error("Error stopping campaign:", err);
            const emsg = err?.response?.data?.message || err.message || "Failed to stop campaign";
            toast.error(emsg);
        }
    };
   const handelSaveCallBack = async (data) =>{
    setSelectedItemCallBack([])
    setCallbackModal(false)
    fetchDetail();
   }


    const uploadCampaignLead = async (formData) => {
        try {
            setLoading(true);
            const finalFileName = getFinalFileName(formData.file);
            const signedUrlPayload = {
                campaign_id: formData.campaign_id,
                file_keys: [finalFileName],
                dump_type: formData.dump_type
            };
            const signedUrlResponse = await ApiService.getSignedUrl(signedUrlPayload);
            if (signedUrlResponse.status !== 200) {
                throw new Error(signedUrlResponse.data?.message || "Failed to get signed URL");
            }
            const signedUrl = signedUrlResponse.data.data[0];
            const uploadResponse = await UploadFile.uploadFile(signedUrl, formData.file);
            if (![200, 201].includes(uploadResponse.status)) {
                throw new Error("File upload failed. Please try again.");
            }
            const uploadLeadPayload = {
                campaign_id: formData.campaign_id,
                files_names: {
                    [finalFileName]: finalFileName,
                },
                dump_type :formData.dump_type
            };
            const uploadLeadResponse = await ApiService.uploadLead(uploadLeadPayload);
            if (uploadLeadResponse.status !== 200) {
                throw new Error(uploadLeadResponse.data?.message || "Upload lead failed");
            }
            toast.success("Lead uploaded successfully");
            fetchDetail();
            setShowModal(false);

        } catch (err) {
            console.error("Error in uploadCampaignLead:", err);
            toast.error(err.message || "Something went wrong while uploading the lead");
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            {Loading && (<></>)}
            <div className="main-contanier">
                <FilterBar
                    control={control}
                    handleSubmit={handleSubmit}
                    onSubmit={handelSubmit}
                    onClearFilters={handleClearFilters}
                    filters={[]}
                    title={"Campaign Overview"}
                    totalCount={pagination.total || 0}
                    tableId="table-id"
                    isDownload={false}
                />
                <div className="table-container dailymis-table" style={{ height: "calc(100vh - 210px)" }}>
                    {Loading && <Loader fullScreen={false} message="Loading campaigns..." />}
                    {
                        tableData.length > 0 ? null : (
                            <div style={{ background: "rgba(247, 71, 71, 1)", width: "100%", height: "30px", display: "flex", justifyContent: "center", alignItems: "center", top: "0", left: "0" }}><span style={{ color: "white", fontWeight: "700", fontSize: "13px" }}>You have no active campaigns at the moment.</span> </div>
                        )
                    }
                    <table id="table-id" className="custom-table-container">
                        <thead
                            className="table-head"
                            style={{ position: "sticky", top: "0", zIndex: "1" }}
                        >
                            <tr>
                                <th style={mistableTh}>S.No</th>
                                {headers.map((header, i) => (
                                    <th key={i} style={mistableTh}>
                                        {header.label}
                                    </th>
                                ))}
                                <th style={mistableTh}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.length > 0 ? (
                                tableData.map((item, index) => (
                                    <tr key={index} style={{ cursor: "pointer" }}>
                                        <td
                                            style={{
                                                ...tableTdStyles,
                                                backgroundColor:
                                                    selectedRowIndex === index ? "#f9faff" : "transparent",
                                            }}
                                        >
                                            {index + 1}
                                        </td>
                                        {headers.map((header, i) => (
                                            <td
                                                key={i}
                                                style={{
                                                    ...tableTdStyles,
                                                    backgroundColor:
                                                        selectedRowIndex === index ? "#f9faff" : "transparent",
                                                }}
                                                title={item[header.value] ?? "--"}
                                            >
                                                {header.value === "status" ? (
                                                    <StatusBadge status={item.status} />
                                                ) : header.value === "disposition" ? (
                                                    <StatusBadge status={item.disposition} />
                                                ) : (
                                                    item[header.value] ?? "--"
                                                )}
                                            </td>
                                        ))}
                                        <td
                                            style={{
                                                ...tableTdStyles,
                                                backgroundColor: selectedRowIndex === index ? "#f9faff" : "transparent",
                                            }}
                                        >
                                            {/* Conditionally render button based on status */}
                                            {item.status?.toLowerCase() === "running" ? (
                                                // Stop button (when campaign is running)
                                                <button
                                                    className="action-btn"
                                                    onClick={() => handleStop(item.id)}
                                                    title="Stop"
                                                >
                                                    <Square size={18} color="red" />
                                                </button>
                                            ) : (
                                                // Start button (when campaign is NOT running)
                                                <button
                                                    className="action-btn"
                                                    onClick={() => handleCallBack(item)}
                                                    title="Start"
                                                >
                                                    <Play size={18} color="green" />
                                                </button>
                                            )}


                                            {/* Add button */}
                                            <button
                                                className="action-btn"
                                                onClick={() => handleAdd(item)}
                                                title="Add"
                                            >
                                                <FilePlus size={18} color="blue" />
                                            </button>

                                             {/* Add button */}
                                            {/* <button
                                                className="action-btn"
                                                onClick={() => handleCallBack(item)}
                                                title="CallBack"
                                            >
                                                <PhoneCall size={18} color="blue" />
                                            </button> */}
                                        </td>

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan={headers.length + 2}
                                        style={tableTdStyles}
                                    >
                                        No data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                {showModal && (
                    <CampaignCreateModal
                        item={selectedItem}
                        onClose={() => setShowModal(false)}
                        onSave={uploadCampaignLead}
                    />
                )}
                 {showCallbackModal && (
                    <CampaignCallbackModel
                        item={selectedItemCallBack}
                        onClose={() => setCallbackModal(false)}
                        onSave={handelSaveCallBack}
                    />
                )}
                <Pagination
                    pagination={pagination}
                    postsPerPage={postsPerPage}
                    handlePageSizeChange={handlePageSizeChange}
                    fetchDetail={fetchDetail}
                />
            </div>
        </>
    );
}
